import React, { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { SystemOutlineLoading } from '@dasa-health/icons'
import { Spacing, ThemeProvider, Body, Heading } from '@dasa-health/alma-react'
import Div100vh from 'react-div-100vh'
import { useSignUp } from 'context'
import { navTheme } from 'theme'
import IllustrationNewUser from 'assets/phased-login/onboarding-new.svg'
import IllustrationMdmUser from 'assets/phased-login/onboarding-mdm.svg'
import { usePhasedLogin } from 'redesign/hooks/usePhasedLogin'
import { IllustrationWrapper, TextWrapper, Wrapper, Illustration, IconSpinnerWrapper } from './styles'

const NEW_USER_CONTENT = {
    title: 'Olá,',
    subtitle: 'Identifiquei que este é seu primeiro acesso, por isso vamos criar sua conta. É rapidinho!',
}

const MDM_USER_CONTENT = {
    title: 'Que bom ver você por aqui!',
    subtitle: 'Como é seu primeiro acesso, vou<br /> confirmar suas informações.<br /> É rapidinho :)',
}

export const OnboardingNewUser = () => {
    const { previousStep, nextStepOnboardingPage, onboardingPage } = usePhasedLogin()
    const { personalData } = useSignUp()
    const { push } = useHistory()

    const contentOnboarding: { title: string; subtitle: string; illustration: string } = useMemo(() => {
        if (personalData?.accountExists) {
            return { title: MDM_USER_CONTENT.title, subtitle: MDM_USER_CONTENT.subtitle, illustration: IllustrationMdmUser }
        }
        return { title: NEW_USER_CONTENT.title, subtitle: NEW_USER_CONTENT.subtitle, illustration: IllustrationNewUser }
    }, [personalData])

    useEffect(() => {
        const pushAndPreviousStep = () => {
            push(nextStepOnboardingPage)
            previousStep()
        }

        if (onboardingPage?.visibility) {
            const timer = setTimeout(pushAndPreviousStep, onboardingPage?.timeout || 2000)
            return () => clearTimeout(timer)
        }
        pushAndPreviousStep()
        return () => {}
    }, [nextStepOnboardingPage, onboardingPage, previousStep, push])

    return (
        <ThemeProvider theme={navTheme}>
            <Div100vh>
                <Wrapper>
                    <TextWrapper>
                        <IconSpinnerWrapper>
                            <SystemOutlineLoading />
                        </IconSpinnerWrapper>
                        <Spacing height={16} />
                        <Heading as="h1" color={navTheme.colors.palette.white}>
                            {contentOnboarding.title}
                        </Heading>
                        <Spacing height={8} />
                        <Body
                            as="h2"
                            color={navTheme.colors.palette.white}
                            dangerouslySetInnerHTML={{ __html: contentOnboarding.subtitle }}
                        />
                    </TextWrapper>
                    <IllustrationWrapper>
                        <Illustration
                            style={{
                                backgroundImage: `url(${contentOnboarding.illustration})`,
                            }}
                        />
                    </IllustrationWrapper>
                </Wrapper>
            </Div100vh>
        </ThemeProvider>
    )
}
